// extracted by mini-css-extract-plugin
export default {"msgM":"_16c524ea12"};